import { reactive } from 'vue';

export const criarManutServico = () => {
    return reactive({
        id: 0,
        idmunicipio: 0,
        cdservico: 0,
        nmservico: '',
        cdcategoria: 1,
        nmcategoria: '',
        informacoes: '',
        ativo: 'S',
        idlogin: 0
    });
}